export enum FeatureFlagKey {
  TasksModule = "tasks-module",
  DocumentAI = "document-ai",
}
